/**
 * @param {string} - The name from the api response ('role:Name')
 * @returns {string} - The name without 'role:' in front of it
 */
export const formatRoleName = name => name.replace('role:', '');
